import { Box, makeStyles, Typography } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Popover from "@material-ui/core/Popover";
import moment from "moment";
import { DateRange } from "react-date-range";
import { useState } from "react";
import CloseIcon from "@material-ui/icons/Close";

import IconButton from "@material-ui/core/IconButton";
const useStyles = makeStyles(() => {
  return {
    datepickerPopover: {
      textAlign: "right",
      fontSize: "16px",
      marginBottom: "33px",
      display: "flex",
      width: "100%",
      justifyContent: "flex-end",
      "& button": {
        backgroundColor: "#ffffff",
        border: "1px solid #d7dae2",
        textTransform: "capitalize",
        "&:hover": {
          backgroundColor: "#ffffff",
        },
      },
    },
  };
});
const DatePickerFilter = (props) => {
  const { dateFilter, setDateFilter } = props;
  const classes = useStyles();

  const [anchorElPicker, setAnchorElPicker] = useState(null);
  const [dateFilterValue, setDateFilterValue] = useState([dateFilter]);

  const handleClickPicker = (event) => {
    setAnchorElPicker(event.currentTarget);
  };
  const handleClearFilter = (event) => {
    setDateFilterValue((prev) => {
      return [{ ...prev[0], startDate: null, endDate: null }];
    });
    setDateFilter({
      startDate: "",
      endDate: "",
    });
  };

  const handleClosePicker = () => {
    setAnchorElPicker(null);
  };

  const handleDateChange = (item) => {
    setDateFilterValue([item.selection]);
    setDateFilter({
      startDate: item.selection.startDate,
      endDate: item.selection.endDate,
    });
  };

  const openPicker = Boolean(anchorElPicker);

  return (
    <div className={classes.datepickerPopover}>
      <div
        style={{
          maxWidth: "260px",
          minWidth: "235px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
        }}
      >
        <Typography
          variant="subtitle2"
          color="secondary"
          style={{
            marginBottom: "0.5rem",
            textAlign: "left",
          }}
        >
          Specify date range
        </Typography>

        <Box display={"flex"} gridColumnGap={"0.5rem"} alignItems={"center"}>
          <Button
            aria-describedby={"date picker"}
            variant="contained"
            onClick={handleClickPicker}
          >
            {dateFilter?.startDate
              ? moment(dateFilter?.startDate).format("DD/MM/YYYY")
              : "DD/MM/YYYY"}{" "}
            -{" "}
            {dateFilter?.endDate
              ? moment(dateFilter?.endDate).format("DD/MM/YYYY")
              : "DD/MM/YYYY"}
          </Button>
          {dateFilter?.startDate || dateFilter?.endDate ? (
            <IconButton
              size="small"
              style={{ height: "1rem", width: "1rem" }}
              onClick={handleClearFilter}
            >
              <CloseIcon />
            </IconButton>
          ) : null}
        </Box>
      </div>
      <Popover
        id={""}
        open={openPicker}
        anchorEl={anchorElPicker}
        onClose={handleClosePicker}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "center",
          horizontal: "center",
        }}
      >
        <DateRange
          editableDateInputs={true}
          onChange={handleDateChange}
          moveRangeOnFirstSelection={false}
          ranges={dateFilterValue}
          startDatePlaceholder="Start date"
          endDatePlaceholder="End date"
          dateDisplayFormat="dd/MM/yyyy"
        />
      </Popover>
    </div>
  );
};
export default DatePickerFilter;
